import { buildPayloadApiUrl, payloadFetch } from "./client";
import { mapHomeCarouselResponse } from "src/utils/mapHomeCarousel";

/**
 * Fetches homepage carousel slides from pg-payload-cms (`home-carousel`).
 * Filtering by publish/unpublish dates is done client-side via shouldPublish().
 * Enabled when `carousels` is listed in `REACT_APP_PAYLOAD_SOURCES`.
 *
 * @param {string} locale - `en` | `fr`
 * @returns {Promise<import('src/utils/mapHomeCarousel').HomeCarouselSlide[]>}
 */
export async function fetchHomeCarousel(locale) {
  const url = buildPayloadApiUrl("/api/home-carousel", {
    locale,
    limit: 50,
    sort: "_order",
    depth: 0,
  });

  const response = await payloadFetch(url);
  return mapHomeCarouselResponse(response, locale);
}
